import Privacy from 'src/screens/privacy/Privacy';

import 'src/components/layout.css';

export default Privacy;
